var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bg-white" },
    [
      _c(
        "div",
        _vm._l(_vm.comments, function (comment) {
          return _c("CommentComponent", {
            key: comment.id,
            staticClass: "px-0",
            attrs: {
              id: "comment-" + comment.id,
              comment: comment,
              user: _vm.user,
              deleteComment: _vm.deleteComment,
              updateComment: _vm.updateComment,
            },
          })
        }),
        1
      ),
      _vm._v(" "),
      _c("CommentCreation", {
        attrs: {
          showCommentForm: _vm.showCommentForm,
          onCancel: function () {
            return (_vm.showCommentForm = false)
          },
          onOpen: function () {
            return (_vm.showCommentForm = true)
          },
          createComment: _vm.createComment,
        },
      }),
      _vm._v(" "),
      _c("ConfirmDialog", { ref: "confirm" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }